import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import appService from "../services/app.service";

export function useAppInitials() {
  const { token } = useSelector((state) => state.auth);
  const initialized = useRef(false);
  useEffect(() => {
    if (!token || initialized.current) return;
    initialized.current = true;
    appService.getInitials().then((success) => {
      if (!success) initialized.current = false;
    });
  }, [token]);
}
